import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CircleUser, CreditCard, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { IconButton, Menu, type MenuItemDef } from '../ui';
import { ThemeSwitch } from './ThemeSwitch';

/** Konto-Menü: e-mail, theme switch, quick links, and Abmelden. */
export const AccountMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const items: Array<MenuItemDef | 'separator'> = [
    {
      label: 'Einstellungen',
      icon: <Settings className="h-4 w-4" aria-hidden="true" />,
      onSelect: () => navigate('/dashboard/settings'),
    },
    {
      label: 'Plan & Upgrade',
      icon: <CreditCard className="h-4 w-4" aria-hidden="true" />,
      onSelect: () => navigate('/dashboard/upgrade'),
    },
    'separator',
    {
      label: 'Abmelden',
      icon: <LogOut className="h-4 w-4" aria-hidden="true" />,
      danger: true,
      onSelect: () => {
        logout();
      },
    },
  ];

  return (
    <Menu
      align="end"
      items={items}
      trigger={(triggerProps) => (
        <IconButton {...triggerProps} label="Konto" icon={<CircleUser className="h-5 w-5" />} />
      )}
      header={
        <>
          {user?.email && <p className="truncate text-sm text-muted">{user.email}</p>}
          <div className="mt-2">
            <ThemeSwitch size="sm" />
          </div>
        </>
      }
    />
  );
};
